import { AnyAction } from 'redux';
import { StoreFont } from '@/types';
import { matchTextAgainstBlocklist } from '@/utils/text/matchTextAgainstBlocklist';
import { getDefaultColor } from '@/model/configuration/getDefaultColor';
import { getAppearance } from '@/model/draft/getAppearance';
import { getLastTextConfiguration } from '@/model/draft/getLastTextConfiguration';
import { ensureFontIsAddedToDocumentAction } from '@/redux/core/actions/ensureFontIsAddedToDocumentAction';
import { getDefaultFont } from '@/redux/core/getters/getDefaultFont';
import { getFonts } from '@/redux/core/getters/getFonts';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { Thunk } from '@/redux/types';
import { addTextAction } from '@/components/draft/draftState/actions/addTextAction';

export const addTextConfigurationAction =
  (
    text: string,
    { color, font, isUserInput }: { color?: string; font?: StoreFont; isUserInput?: boolean } = {}
  ): Thunk<void, AnyAction> =>
  async (dispatch, getState) => {
    const state = getState();

    const lastTextConfiguration = getLastTextConfiguration(getDraft(state));
    if (!font) {
      font = lastTextConfiguration?.text.style.font || getDefaultFont(getFonts(state));
    }

    if (!color) {
      color =
        lastTextConfiguration?.printColors[0].fill ||
        getDefaultColor(getAppearance(getDraft(state)));
    }

    const [loadedFont, copyrightError] = await Promise.all([
      dispatch(ensureFontIsAddedToDocumentAction(font)),
      isUserInput ? matchTextAgainstBlocklist(text) : Promise.resolve(''),
    ]);

    getDraftDispatch(state)(addTextAction(text, loadedFont, color, copyrightError));
  };
